import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Phone, Clock, List, X } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_eatech-portal/artifacts/l3j7s7xc_logo.png";

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: "ACCUEIL", path: "/" },
    { name: "QUI NOUS SOMMES", path: "/qui-nous-sommes" },
    { name: "QUE FAISONS-NOUS", path: "/#services", isHash: true },
    { name: "NOUS CONTACTER", path: "/nous-contacter" },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="w-full z-50" data-testid="header">
      {/* Top bar */}
      <div className="bg-sky-500 text-white py-2 px-4">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row justify-between items-center text-sm">
          <div className="flex items-center gap-2">
            <Clock size={16} weight="bold" />
            <span>Horaires : <strong>10:00 - 12h / 13h - 18:00</strong></span>
          </div>
          <div className="flex items-center gap-2 mt-1 sm:mt-0">
            <Phone size={16} weight="bold" />
            <span>Contact: <strong>+33 3 55 20 50 51</strong></span>
          </div>
        </div>
      </div>

      {/* Main navigation */}
      <nav className="bg-white shadow-sm border-b border-slate-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            {/* Logo */}
            <Link to="/" className="flex-shrink-0" data-testid="logo-link">
              <img 
                src={LOGO_URL} 
                alt="E@Tech Logo" 
                className="h-20 w-auto"
              />
            </Link>

            {/* Desktop Navigation */}
            <div className="hidden lg:flex items-center gap-8">
              {navLinks.map((link) => (
                link.isHash ? (
                  <a
                    key={link.path}
                    href={link.path}
                    className="nav-link text-sm font-medium transition-colors text-slate-700 hover:text-sky-500"
                    data-testid={`nav-que-faisons-nous`}
                  >
                    {link.name}
                  </a>
                ) : (
                  <Link
                    key={link.path}
                    to={link.path}
                    className={`nav-link text-sm font-medium transition-colors ${
                      isActive(link.path)
                        ? "text-sky-500"
                        : "text-slate-700 hover:text-sky-500"
                    }`}
                    data-testid={`nav-${link.path.replace("/", "") || "home"}`}
                  >
                    {link.name}
                  </Link>
                )
              ))}
            </div>

            {/* CTA Button */}
            <div className="hidden lg:flex items-center gap-4">
              <Link to="/demande-devis">
                <Button 
                  className="bg-blue-700 hover:bg-blue-800 text-white px-6 py-2 font-medium"
                  data-testid="cta-devis-btn"
                >
                  DEMANDE DE DEVIS
                </Button>
              </Link>
            </div>

            {/* Mobile menu button */}
            <button
              className="lg:hidden p-2 text-slate-700"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              data-testid="mobile-menu-btn"
            >
              {mobileMenuOpen ? <X size={28} /> : <List size={28} />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="lg:hidden bg-white border-t border-slate-100 py-4 px-4">
            <div className="flex flex-col gap-4">
              {navLinks.map((link) => (
                link.isHash ? (
                  <a
                    key={link.path}
                    href={link.path}
                    className="text-sm font-medium py-2 text-slate-700"
                    onClick={() => setMobileMenuOpen(false)}
                    data-testid="mobile-nav-que-faisons-nous"
                  >
                    {link.name}
                  </a>
                ) : (
                  <Link
                    key={link.path}
                    to={link.path}
                    className={`text-sm font-medium py-2 ${
                      isActive(link.path)
                        ? "text-sky-500"
                        : "text-slate-700"
                    }`}
                    onClick={() => setMobileMenuOpen(false)}
                    data-testid={`mobile-nav-${link.path.replace("/", "") || "home"}`}
                  >
                    {link.name}
                  </Link>
                )
              ))}
              <Link 
                to="/demande-devis" 
                onClick={() => setMobileMenuOpen(false)}
              >
                <Button 
                  className="bg-blue-700 hover:bg-blue-800 text-white w-full mt-2"
                  data-testid="mobile-cta-devis-btn"
                >
                  DEMANDE DE DEVIS
                </Button>
              </Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}
